/* Página atualizada e funcionando

Essa parte de layouts serve para chamar o código que está em pages, onde tudo é realmente montado.

*/

import Treinamento from "pages/AcademiaCiber/Treinamento";

export default function TreinamentoPage() {
  return <Treinamento />;
}
